module.exports = __webpack_public_path__ + "img/swiper1.39f0ea9a.png";